import React, { useEffect, useState } from "react";
import { TextField } from "@mui/material";

const TextFieldSimpleComponent = (props: any) => {
    return (
        <div className={props.divClassName}>
            <TextField
                autoFocus={props.autoFocus ?? false}
                fullWidth
                className={props.className}
                required={props.required}
                disabled={props.disabled ?? false}
                onChange={(e: any) => props.onChange(e.target.value)} 
                label={props.label}
                variant={props.variant ?? "outlined"}
                type={props.type ?? 'text'}
                inputProps={props.inputProps}
                value={props.value}
                style={{ marginRight: 10 }} />
        </div>
    )
}

export default TextFieldSimpleComponent